import React, { useRef } from 'react';
import { ATTACH_ACCEPT, ATTACH_WORDS, attachProblem } from '../../lib/licences';

/**
 * FILES CHOSEN ON THE ADD FORM (wave 7), for a licence or a contract: the
 * contract, the invoice, the email that agreed it. The form itself is JSON
 * and the upload endpoint multipart, so nothing is sent here - the form
 * adds the record first, then uploads each file to it (uploadAll below), and
 * the record's page lists them. A file the register would refuse (not PDF,
 * Word, Excel, an image or an email, or over 10 MB) is said at once and
 * not kept.
 *
 *   files     [{ file, doc_type }]
 *   onChange  the new list
 *   docTypes  { value: label } - the register's kinds of document
 */
export default function AttachFiles({ files, onChange, docTypes, defaultType, onProblem, prefix = 'lic' }) {
  const input = useRef(null);
  const add = (e) => {
    const chosen = [...(e.target.files || [])];
    const bad = chosen.map(attachProblem).filter(Boolean);
    onProblem(bad.join(' '));
    onChange([...files, ...chosen.filter((f) => !attachProblem(f)).map((file) => ({ file, doc_type: defaultType }))]);
    if (input.current) input.current.value = '';
  };
  return (
    <div className="lic-field lic-field-wide" data-testid={`${prefix}-attach`}>
      <label htmlFor={`${prefix}-attach-input`}>Documents</label>
      {files.length > 0 && (
        <ul className="lic-docs lic-attach-list" aria-label="Files to attach">
          {files.map((f, i) => (
            <li key={`${f.file.name}-${i}`}>
              <span className="lic-doc-name">{f.file.name}</span>
              <select aria-label={`Kind of document: ${f.file.name}`} value={f.doc_type}
                onChange={(e) => onChange(files.map((x, j) => (j === i ? { ...x, doc_type: e.target.value } : x)))}>
                {Object.entries(docTypes).map(([v, w]) => <option key={v} value={v}>{w}</option>)}
              </select>
              <button type="button" className="btn btn-plain btn-small" aria-label={`Do not attach ${f.file.name}`}
                onClick={() => onChange(files.filter((_, j) => j !== i))}>Remove</button>
            </li>
          ))}
        </ul>
      )}
      <input id={`${prefix}-attach-input`} ref={input} type="file" multiple accept={ATTACH_ACCEPT} onChange={add} />
      <p className="lic-hint">{`${ATTACH_WORDS}, 10 MB each at most. Attached once it is added.`}</p>
    </div>
  );
}

/**
 * Upload each chosen file to the record just added. Answers the sentences
 * for any that failed (the record stands either way; they can be attached
 * again from its page).
 */
export async function uploadAll(files, upload, errorOf) {
  const failed = [];
  for (const f of files) {
    const form = new FormData();
    form.append('file', f.file);
    form.append('doc_type', f.doc_type);
    try {
      await upload(form);
    } catch (e) {
      failed.push(errorOf(e, `${f.file.name} could not be attached.`));
    }
  }
  return failed;
}
